import { render, staticRenderFns } from "./ContractorUpdate.vue?vue&type=template&id=54db15cc&"
import script from "./ContractorUpdate.vue?vue&type=script&lang=js&"
export * from "./ContractorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports